import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

const Resources = () => {
  return (
    <section
      id="resources"
      data-testid="section-resources"
      className="py-24 lg:py-32"
      style={{ backgroundColor: '#F7F5EE', scrollMarginTop: '5rem' }}
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-12">
          <p className="text-[13px] uppercase tracking-widest mb-4" style={{ color: 'var(--yb-muted)' }}>
            Resources
          </p>
          <h2
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em]"
            style={{ color: 'var(--yb-ink)' }}
          >
            Resources
          </h2>
          <p className="mt-6 text-[16px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
            Guides and ideas to help you get the most out of YouBuild.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
          <Link
            to="/blog"
            data-testid="resources-blog-card"
            className="group bg-white rounded-2xl border p-7 flex flex-col justify-between shadow-[0_6px_24px_-18px_rgba(23,21,59,0.25)] transition-all"
            style={{ borderColor: 'var(--yb-border)' }}
          >
            <div>
              <span
                className="w-11 h-11 rounded-xl flex items-center justify-center mb-5"
                style={{ backgroundColor: '#EEF2FF', color: 'var(--yb-indigo)' }}
              >
                <BookOpen size={20} />
              </span>
              <h3
                className="font-serif text-2xl sm:text-3xl leading-tight tracking-tight"
                style={{ color: 'var(--yb-ink)' }}
              >
                Read the blog
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
                Stories, ideas, and behind the scenes notes from the YouBuild team.
              </p>
            </div>
            <span
              className="mt-6 inline-flex items-center gap-1.5 text-[14px] font-medium group-hover:gap-2.5 transition-all"
              style={{ color: 'var(--yb-indigo)' }}
            >
              Read the blog <ArrowRight size={15} />
            </span>
          </Link>

          <div
            data-testid="resources-more-coming"
            className="rounded-2xl border p-7 flex items-center"
            style={{ borderColor: 'var(--yb-border)', backgroundColor: 'transparent', borderStyle: 'dashed' }}
          >
            <p className="text-[15px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
              More guides and tutorials are on the way.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resources;
